import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { FaXTwitter, FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa6';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import './App.css';

function App() {
  return (
    <Router>
      {/* Top Navigation Bar */}
      <nav className="top-nav">
        {/* Social Media Icons */}
        <div className="social-icons">
          <a href="https://x.com/cooked2cracked" target="_blank" rel="noopener noreferrer">
            <FaXTwitter className="nav-icon" />
          </a>
          <a href="mailto:aryapofficial@gmail.com">
            <FaEnvelope className="nav-icon" />
          </a>
          <a href="https://www.linkedin.com/in/arya-punjabi/" target="_blank" rel="noopener noreferrer">
            <FaLinkedin className="nav-icon" />
          </a>
          <a href="https://github.com/arya-2407/" target="_blank" rel="noopener noreferrer">
            <FaGithub className="nav-icon" />
          </a>
        </div>

        {/* Navigation Links */}
        <ul className="nav-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/projects">Portfolio</Link></li>
          <li><Link to="/contact">Contact</Link></li>
        </ul>
      </nav>

      {/* Page Content */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
